import { NavigationItem } from 'app/core/interfaces/navigation-item';
import { Actions } from 'app/core/security/actions';

import {
    SidebarReportResources,
    SidebarResources,
    SidebarSettingsResources,
} from 'app/core/security/resources/sidebar';

export const SHONavigationItems: Record<
    string,
    NavigationItem | { type: 'divider' }
> = {
    dashboard: {
        title: 'Dashboard',
        type: 'basic',
        icon: 'dashboard-speed-01',
        link: 'app/dashboard',
        permission: {
            resource: SidebarResources.DASHBOARD,
            actions: [Actions.RENDER],
        },
    },
    booking: {
        title: 'Bookings',
        type: 'basic',
        icon: 'maps-search',
        link: 'app/booking',
        permission: {
            resource: SidebarResources.BOOKING,
            actions: [Actions.RENDER],
        },
    },
    show: {
        title: 'Show',
        type: 'basic',
        icon: 'joker',
        link: 'app/show',
        permission: {
            resource: SidebarResources.SHOW,
            actions: [Actions.RENDER],
        },
    },
    venue: {
        title: 'Venue',
        type: 'basic',
        icon: 'calendar-01',
        link: 'app/venue',
        permission: {
            resource: SidebarResources.VENUE,
            actions: [Actions.RENDER],
        },
    },
    // free_kids_tickets: {
    //     title: 'Free Kids Tickets',
    //     // subtitle: 'Assign to a task or a project',
    //     type: 'collapsable',
    //     icon: 'ticket-03',
    //     link: 'app/tickets',
    //     // badge: {
    //     //     title: '49',
    //     //     classes:
    //     //         'px-2 bg-primary text-on-primary rounded-full',
    //     // },
    //     children: [
    //         {
    //             title: 'Employee Payroll Report',
    //             type: 'basic',
    //             icon: 'dashboard-circle',
    //             link: 'app/tickets/employee_payroll_report',
    //         },
    //     ],
    // },
    // promotions: {
    //     title: 'Promotions',
    //     type: 'basic',
    //     icon: 'coupon-01',
    //     link: 'app/promotions',
    //     // badge: {
    //     //     title: '10',
    //     //     classes:
    //     //         'px-2 bg-success text-on-primary rounded-full',
    //     // },
    // },
    // trucking: {
    //     title: 'Trucking',
    //     type: 'basic',
    //     icon: 'container-truck',
    //     link: 'app/trucking',
    // },
    // concession: {
    //     title: 'Concession',
    //     type: 'collapsable',
    //     icon: 'store-01',
    //     link: 'app/concession',
    //     children: [
    //         {
    //             title: 'Inventory',
    //             type: 'basic',
    //             icon: 'invoice',
    //             link: 'app/concession/inventory',
    //         },
    //     ],
    // },
    // accounting: {
    //     title: 'Accounting',
    //     type: 'collapsable',
    //     icon: 'student-card',
    //     link: 'app/accounting',
    //     children: [
    //         {
    //             title: 'Company Expenses',
    //             type: 'basic',
    //             icon: 'invoice',
    //             link: 'app/accounting/company_expenses',
    //         },
    //     ],
    // },
    reports: {
        title: 'Reports',
        type: 'collapsable',
        icon: 'analytics-02',
        link: 'app/reports',
        permission: {
            resource: SidebarReportResources.REPORTS,
            actions: [Actions.RENDER],
        },
        children: [
            {
                title: 'Profit & Loss',
                type: 'basic',
                icon: 'add-money-circle',
                link: 'app/reports/profit_loss',
                permission: {
                    resource: SidebarReportResources.PROFIT_AND_LOSS,
                    actions: [Actions.RENDER],
                },
            },
            // {
            //   title: 'Venue Profit & Expenses',
            //   type: 'basic',
            //   icon: 'invoice-03',
            //   link: 'app/reports/venue_profit_expenses',

            // },
            {
                title: 'Show Expenses',
                type: 'basic',
                icon: 'invoice-03',
                link: 'app/reports/show_expenses',
                permission: {
                    resource: SidebarReportResources.SHOW_EXPENSES,
                    actions: [Actions.RENDER],
                },
            },
            {
                title: 'Office Expenses',
                type: 'basic',
                icon: 'new-office',
                link: 'app/reports/office_expenses',
                permission: {
                    resource: SidebarReportResources.OFFICE_EXPENSES,
                    actions: [Actions.RENDER],
                },
            },
            {
                title: 'Onsite Expenses',
                type: 'basic',
                icon: 'plate',
                link: 'app/reports/onsite_expenses',
                permission: {
                    resource: SidebarReportResources.ONSITE_EXPENSES,
                    actions: [Actions.RENDER],
                },
            },
            {
                title: 'Combined Expenses',
                type: 'basic',
                icon: 'affiliate',
                link: 'app/reports/combined_expenses',
                permission: {
                    resource: SidebarReportResources.COMBINED_EXPENSES,
                    actions: [Actions.RENDER],
                },
            },
            {
                title: 'Final',
                type: 'basic',
                icon: 'chart-histogram',
                link: 'app/reports/final_report',
                permission: {
                    resource: SidebarReportResources.FINAL_ANALYSIS,
                    actions: [Actions.RENDER],
                },
            },
            {
                title: 'Cost',
                type: 'basic',
                icon: 'coins-01',
                link: 'app/reports/cost_analysis',
                permission: {
                    resource: SidebarReportResources.COST_ANALYSIS,
                    actions: [Actions.RENDER],
                },
            },
            {
                title: 'Inventory Sales',
                type: 'basic',
                icon: 'discount-tag-02',
                link: 'app/reports/sales_analysis',
                permission: {
                    resource: SidebarReportResources.INVENTORY_SALES_ANALYSIS,
                    actions: [Actions.RENDER],
                },
            },
            //  {
            //    title: 'Manager Report',
            //    type: 'basic',
            //    icon: 'file-management',
            //    link: 'app/reports/manager_report',
            //  },
            // {
            //   title: 'Item Sales (Final Report)',
            //   type: 'basic',
            //   icon: 'discount-tag-02',
            //   link: 'app/reports/company_expenses',
            // },
        ],
    },
    inventory: {
        title: 'Inventory',
        type: 'basic',
        icon: 'bar-code-02-stroke-rounded',
        link: 'app/inventory',
        permission: {
            resource: SidebarResources.INVENTORY,
            actions: [Actions.RENDER],
        },
    },
    vendors: {
        title: 'Vendors',
        type: 'basic',
        icon: 'fuel-station',
        link: 'app/vendors',
        permission: {
            resource: SidebarResources.VENDORS,
            actions: [Actions.RENDER],
        },
    },
    gateway_management: {
        title: 'Gateway Sales',
        type: 'basic',
        icon: 'product-loading',
        link: 'app/gateway_management',
        permission: {
            resource: SidebarResources.GATEWAY_MANAGEMENT,
            actions: [Actions.RENDER],
        },
    },
    divider: {
        type: 'divider',
    },
    settings: {
        title: 'Settings',
        type: 'collapsable',
        icon: 'setting-04',
        permission: {
            resource: SidebarSettingsResources.SETTINGS,
            actions: [Actions.RENDER],
        },
        children: [
            // {
            //   title: 'Inventory',
            //   type: 'basic',
            //   icon: 'invoice',
            //   link: 'app/settings/inventory',
            // },
            {
                title: 'Generals',
                type: 'basic',
                icon: 'geometric-shapes-01',
                link: 'app/generals',
                permission: {
                    resource: SidebarSettingsResources.GENERAL,
                    actions: [Actions.RENDER],
                },
            },
            {
                title: 'Users',
                type: 'basic',
                icon: 'user-circle',
                link: 'app/users',
                permission: {
                    resource: SidebarSettingsResources.USERS,
                    actions: [Actions.RENDER],
                },
            },
            // {
            //   title: 'Equipments',
            //   type: 'basic',
            //   icon: 'tow-truck',
            //   link: 'app/equipments',
            //   permission: 'VIEW_SIDEBAR_EQUIPMENTS',
            // },
            // {
            //   title: 'Types',
            //   type: 'basic',
            //   icon: 'geometric-shapes-01',
            //   link: 'app/types',
            //   permission: 'VIEW_SIDEBAR_TYPES',
            // },
            {
                title: 'Chart of Accounts',
                type: 'basic',
                icon: 'binary-code',
                link: 'app/chart_of_accounts',
                permission: {
                    resource: SidebarSettingsResources.CHART_OF_ACCOUNTS,
                    actions: [Actions.RENDER],
                },
            },
            {
                title: 'Gateway',
                type: 'basic',
                icon: 'gateway',
                link: 'app/gateway',
                permission: {
                    resource: SidebarSettingsResources.GATEWAY,
                    actions: [Actions.RENDER],
                },
            },

            // Inventory
            {
                title: 'Inventory Items',
                type: 'basic',
                icon: 'shopify',
                link: 'app/inventory/inventory_items',
                permission: {
                    resource: SidebarSettingsResources.INVENTORY_ITEMS,
                    actions: [Actions.RENDER],
                },
            },
            {
                title: 'Inventory Locations',
                type: 'basic',
                icon: 'entering-geo-fence',
                link: 'app/inventory/inventory_locations',
                permission: {
                    resource: SidebarSettingsResources.INVENTORY_LOCATIONS,
                    actions: [Actions.RENDER],
                },
            },
            {
                title: 'Sales Locations',
                type: 'basic',
                icon: 'store-location-02',
                link: 'app/inventory/sales_locations',
                permission: {
                    resource: SidebarSettingsResources.SALES_LOCATIONS,
                    actions: [Actions.RENDER],
                },
            },
            // {
            //   title: 'Mailing Cost Accounts',
            //   type: 'basic',
            //   icon: 'mail-open',
            //   link: 'app/mailing_cost_accounts',
            // },
            // {
            //   title: 'Inventory Category',
            //   type: 'basic',
            //   icon: 'product-loading',
            //   link: 'app/inventory_category',
            // },
            {
                title: 'Employees',
                type: 'basic',
                icon: 'user-group',
                link: 'app/employees',
                permission: {
                    resource: SidebarSettingsResources.EMPLOYEES,
                    actions: [Actions.RENDER],
                },
            },
        ],
    },
    divider2: {
        type: 'divider',
    },
    help: {
        title: 'Help',
        type: 'collapsable',
        icon: 'help-square',
        link: 'app/help',
        permission: {
            resource: SidebarSettingsResources.GENERAL,
            actions: [Actions.RENDER],
        },
    },
};

// settingsChildren: [
//   {
//     title: 'Inventory',
//     type: 'basic',
//     icon: 'invoice',
//     link: 'app/settings/inventory',
//   },
//   {
//     title: 'Users',
//     type: 'basic',
//     icon: 'user-circle',
//     link: 'app/users',
//   },
//   {
//     title: 'Employees',
//     type: 'basic',
//     icon: 'user-group',
//     link: 'app/employees',
//   },
//   {
//     title: 'Equipments',
//     type: 'basic',
//     icon: 'container-truck',
//     link: 'app/equipments',
//   },
//   {
//     title: 'Types',
//     type: 'basic',
//     icon: 'dashboard-circle',
//     link: 'app/types',
//   },
//   {
//     title: 'Chart of Accounts',
//     type: 'basic',
//     icon: 'dashboard-circle',
//     link: 'app/chart_of_accounts',
//   },
//   {
//     title: 'Mailing Cost Accounts',
//     type: 'basic',
//     icon: 'dashboard-circle',
//     link: 'app/mailing_cost_accounts',
//   },
//   {
//     title: 'Inventory Category',
//     type: 'basic',
//     icon: 'dashboard-circle',
//     link: 'app/inventory_category',
//   },
// ];
